import React, { Component } from "react";
import { connect } from "react-redux";
import editImage from "../../images/edit.png";
import removeImage from "../../images/close.png";

class AddressList extends Component {
  render() {
    const {
      addresses,
      deliveryOption,
      handleDeliveryChange,
      clickEditAddress,
      clickRemoveAddress
    } = this.props;
    const addressList =
      (addresses._embedded && addresses._embedded.addresses) || [];

    return (
      <ul>
        {addressList &&
          addressList.map((address, index) => (
            <li key={index} style={{ position: "relative" }}>
              <input
                type="radio"
                id={"delivery_address" + index}
                name="delivery_address_radioGrp"
                value={address.id}
                onChange={e => handleDeliveryChange(e, address.countryCode)}
                checked={
                  address.id === deliveryOption.delivery_address_radioGrp.value
                }
              />
              <label htmlFor={"delivery_address" + index}>
                {address.rcptFirstNam},{address.rcptMobCtryCde}
                {address.rcptMobNbr}
                <br />
                {`${address.address1}${
                  address.address2 === null ? "" : ", " + address.address2
                }`}
                <br />
                {address.city}, {address.province},{" "}
                {address.countryCode === "HK" ? null : `${address.postCode}, `}
                {address.country}
              </label>
              <div
                style={{
                  display: "inline-block",
                  verticalAlign: "top",
                  position: "absolute",
                  right: "0"
                }}
              >
                <span
                  style={{
                    cursor: "pointer",
                    opacity: "0.5",
                    paddingRight: "10px"
                  }}
                  onClick={clickEditAddress.bind(this, address)}
                >
                  <img
                    src={editImage}
                    style={{ width: "16px" }}
                    alt=""
                    loading="lazy"
                  />
                </span>
                <span
                  style={{
                    cursor: "pointer",
                    opacity: "0.5"
                  }}
                  onClick={clickRemoveAddress.bind(this, address)}
                >
                  <img
                    src={removeImage}
                    style={{ width: "14px" }}
                    alt=""
                    loading="lazy"
                  />
                </span>
              </div>
            </li>
          ))}
      </ul>
    );
  }
}

const mapStateToProps = state => ({
  addresses: state.addresses.addressesData
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddressList);
